export default function Error ({message}) {
    return (
        <div className="flex items-center justify-center error-container max-w-5xl">
            <div>
                <span className="block text-sm">{message}</span>
            </div>
        </div>
    );
}